var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"12","height":"7","viewBox":"0 0 12 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.44727 1L6.44727 6L11.4473 1","stroke":"currentColor","stroke-linecap":"round"}})])}
var staticRenderFns = []

export { render, staticRenderFns }